﻿var oc = {};
(function ($) {

    oc.locale = {};
    var captchaLocales = {};


    function setCaptchaLocales() {
        captchaLocales = {
            en: {
                "requiredMessage": "You must prove you're not a robot by ticking the box."
            },
            no: {
                "requiredMessage": "Du må bevise at du ikke er en robot ved å klikke i ruten."
            },
            sv: {
                "requiredMessage": "Klicka i rutan för att bevisa att du inte är en robot."
            },
            da: {
                "requiredMessage": "Du skal bevise, at du ikke er en robot ved at klikke i feltet."
            },
            fi: {
                "requiredMessage": "Todista, että et ole robotti napsauttamalla ruutua."
            }
        };
    }


    function currentLangCode() {
        var langCodeTwo = $("input#langCodeTwo").val();
        if (langCodeTwo === null || langCodeTwo === "" || langCodeTwo === undefined) {
            langCodeTwo = "no";
        }
        return langCodeTwo;
    }


    function initLocale() {
        setCaptchaLocales();
        oc.locale = captchaLocales[currentLangCode()];
    }


    function validateCaptcha(value, element) {
        return (value || "").length > 0;
    }


    function initCaptcha() {
        initLocale();
        //$(".g-recaptcha").attr("data-callback", "reCaptchaCallback(this)");
        $.validator.addMethod("recaptcha", validateCaptcha, oc.locale.requiredMessage || "This field is required (locale message not found).");
        $.validator.setDefaults({
            ignore: ":hidden:not([name='hiddenRecaptcha'])"
        });
    }


    oc.initialize = function () {
        initCaptcha();
    };

    oc.captchaExist = function () {
        var grecaptchaResponse = document.getElementById("g-recaptcha-response");
        if (grecaptchaResponse) {
            return true;
        } else {
            return false;
        }
    };

    oc.initialize();

}(window.jQuery));


function reCaptchaCallback() {
    // <This should be working automatically>
    
    $("#hiddenRecaptcha").val(response);
    // </This should be working automatically>
    $("#hiddenRecaptcha").valid();
}

